import { render, staticRenderFns } from "./exportDeclare.vue?vue&type=template&id=200c2900&scoped=true"
import script from "./exportDeclare.vue?vue&type=script&lang=js"
export * from "./exportDeclare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c2900",
  null
  
)

export default component.exports